<template>
  <div :class="$style.base">
    <SearchBar v-show="services.length > 14" v-model="searchQuery" />
    <div
      ref="el"
      :class="$style.list"
      @scroll="onScroll"
      v-test="'service-list-scroll-box'"
    >
      <SelectServicesCategory
        v-for="(category, index) in filteredCategories"
        :key="index"
        :data="category"
        @submit="$emit('submit')"
        @scrollTo="scrollTo"
        @scrolledToTop="$emit('categoryScrolled', $event)"
        v-test="'service-category'"
      />
    </div>

    <div
      v-if="hasScrolled && services.length > 14"
      :class="$style.arrow"
      @click="scrollTo(0)"
      v-test="'services-scroll-arrow'"
    >
      <IconArrow :class="$style.arrowIcon" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ServiceCategory, ServiceVariationGroupCategory } from '@/types';
import { computed, ref } from 'vue';

import { useServicesStore } from '@/stores/services';

import IconArrow from '@/components/IconArrow.vue';
import SearchBar from './SearchBar.vue';
import SelectServicesCategory from './SelectServicesCategory.vue';

const emit = defineEmits(['submit', 'scroll', 'categoryScrolled']);

const { services } = useServicesStore();
const searchQuery = ref('');

const filteredCategories = computed(() => {
  const { categories, filterServiceCategories } = useServicesStore();

  if (!searchQuery.value) {
    return categories;
  }

  return filterServiceCategories(
    categories as ServiceVariationGroupCategory[] & ServiceCategory[],
    searchQuery.value
  );
});

const el = ref<HTMLElement | null>();

const scrollTo = (top: number) => {
  el.value?.scrollTo({
    top: top + 1, // Add one pixel the hide the bottom border
    behavior: 'smooth'
  });
};

const hasScrolled = ref(false);

const onScroll = (event: any) => {
  emit('scroll', event);
  hasScrolled.value = !!el.value?.scrollTop && el.value?.scrollTop > 50;
};
</script>

<style lang="scss" module>
$btn-size: $spacing * 2 + 16px; //16px is the width of the arrow

.base {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.list {
  position: relative; // Needed for correct offsetTop of child elements
  @include page;
}

.notFound {
  padding: $spacing;
}

.arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: $spacing;
  right: $spacing;
  height: 100%;
  width: $btn-size;
  height: $btn-size;
  background-color: inherit;
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
  @include box-shadow;
  transform: rotate(90deg);
}
</style>
